export function Stability() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-slate-900">Stability</h1>
      <p className="text-sm text-slate-500">System stability scores and SLA tracking.</p>
      <div className="rounded-xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <p className="text-slate-400">Stability metrics will appear here.</p>
      </div>
    </div>
  )
}
